"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocaleOptions = getLocaleOptions;

var _underscore = require("underscore");

var _I18n = _interopRequireDefault(require("I18n"));

function getLocaleOptions(localesArray) {
  return (0, _underscore.map)(localesArray, function (value) {
    return {
      text: _I18n.default.text("leadFlowEditor.leadFlowFormEditor.languages." + value),
      value: value
    };
  });
}